import { Scale } from "lucide-react";

export default function Logo({ size = 36, withText = true, compact = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="app-logo">
      <div
        className="relative flex items-center justify-center rounded-sm bg-marine text-gold shrink-0"
        style={{ width: size, height: size }}
        aria-hidden="true"
      >
        <Scale size={size * 0.6} strokeWidth={2.25} />
        <span className="absolute -bottom-1 -right-1 block h-1.5 w-1.5 rounded-sm bg-gold"></span>
      </div>
      {withText && (
        <div className="flex flex-col leading-none">
          <span className="font-serif font-black tracking-tight text-[15px] text-marine dark:text-gold">
            DEBT-ANALYZER {compact ? "" : <span className="text-gold dark:text-foreground">PRO</span>}
          </span>
          {!compact && (
            <span className="label-mono text-[9px] mt-1 text-muted-foreground">
              Analyse · Dette · Souveraineté
            </span>
          )}
        </div>
      )}
    </div>
  );
}
